<script setup lang="ts">
import { cn } from '../../libs/utils';
import type { WithClassAsProps } from './interface';

defineOptions({
  inheritAttrs: false,
});

const props = defineProps<WithClassAsProps>();
</script>

<template>
  <swiper-container :class="cn('w-full h-full', props.class)" v-bind="$attrs" :init="false">
    <slot />
  </swiper-container>
</template>
